/* Black Friday 2026 (Nubra, port din Esteban, 2 nov) — cronometre, închiderea lander-ului, măsurare.
   Starea (bf-on / bf-lander / bf-closed) e pusă înainte de pictare de snippets/nubra-bf-head.liquid; aici doar interacțiunea.
   Cronometrul numără spre o oră reală, aceeași pentru toți (sfârșitul campaniei sau miezul nopții, ora României). */
(function () {
  var BF = window.NB_BF;
  if (!BF || !BF.on) return;
  var H = document.documentElement;

  function now() { return Date.now() + (BF.offset || 0); }
  function roParts(t) {
    var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Bucharest', hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(new Date(t));
    var o = {}; p.forEach(function (x) { o[x.type] = +x.value; }); return o;
  }
  function target() {
    if (BF.mode === 'midnight') { var r = roParts(now()); return now() + (86400 - ((r.hour % 24) * 3600 + r.minute * 60 + r.second)) * 1000; }
    return BF.end;
  }
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  var els = [];
  function collect() { els = Array.prototype.slice.call(document.querySelectorAll('[data-bf-t]')); }
  function tick() {
    var s = Math.max(0, Math.floor((target() - now()) / 1000));
    var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), x = s % 60;
    for (var i = 0; i < els.length; i++) {
      var e = els[i];
      if (e.getAttribute('data-bf-t') === 'boxes') {
        var u = e.querySelectorAll('[data-u]');
        for (var j = 0; j < u.length; j++) {
          var k = u[j].getAttribute('data-u'), b = u[j].querySelector('b');
          if (k === 'd') { u[j].hidden = d === 0; b.textContent = d; }
          else b.textContent = pad(k === 'h' ? h : k === 'm' ? m : x);
        }
      } else {
        e.textContent = (d > 0 ? d + (d === 1 ? ' zi ' : ' zile ') : '') + pad(h) + ':' + pad(m) + ':' + pad(x);
      }
    }
    if (s === 0 && BF.mode !== 'midnight') { H.classList.remove('bf-on'); clearInterval(iv); }
  }
  collect(); tick();
  var iv = setInterval(function () { if (!document.hidden) tick(); }, 1000);
  /* coșul / secțiunile reîncărcate prin AJAX aduc cronometre noi */
  document.addEventListener('cart:update', function () { setTimeout(function () { collect(); tick(); }, 50); });
  var pend = false;
  new MutationObserver(function () {
    if (pend) return; pend = true;
    setTimeout(function () { pend = false; var n = document.querySelectorAll('[data-bf-t]').length; if (n !== els.length || els.some(function (e) { return !e.isConnected; })) { collect(); tick(); } }, 300);
  }).observe(document.body, { childList: true, subtree: true });

  /* măsurare: evenimentul Shopify nb_cta_click (Customer events) + Clarity, dacă e încărcat */
  function track(name) {
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('nb_cta_click', { cta: name, page_type: document.body.dataset.template || '' }); } catch (e) {}
    try { if (window.clarity) window.clarity('event', name); } catch (e) {}
  }
  function clarityTags() {
    try {
      if (!window.clarity) return;
      window.clarity('set', 'bf', 'on');
      if (document.querySelector('.nb-bfl')) window.clarity('set', 'bf_lander', H.classList.contains('bf-closed') ? 'inchis' : 'deschis');
    } catch (e) {}
  }
  clarityTags(); window.addEventListener('load', function () { setTimeout(clarityTags, 3000); });

  /* închiderea / redeschiderea lander-ului (ține minte N ore) */
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-bf-close], [data-bf-open], [data-bf-cta]');
    if (!c) return;
    if (c.hasAttribute('data-bf-close')) {
      H.classList.add('bf-closed');
      try { localStorage.setItem('nb_bf_closed', String(Date.now() + (BF.hours || 12) * 3600000)); } catch (x) {}
      track('bf_lander_close'); clarityTags();
      window.scrollTo({ top: 0 });
      window.dispatchEvent(new Event('resize'));
    } else if (c.hasAttribute('data-bf-open')) {
      H.classList.remove('bf-closed');
      try { localStorage.removeItem('nb_bf_closed'); } catch (x) {}
      track('bf_lander_open'); clarityTags();
      window.scrollTo({ top: 0 });
    } else {
      track(c.getAttribute('data-bf-cta'));
    }
  });
})();
